import React from 'react'
import MaskedInput from 'react-maskedinput'
import { connect } from 'react-redux'
import { isEqual } from 'lodash'
import { editUser, becomeBetter, changePass } from '../../actions/authActions'

class UserdataPage extends React.Component {

  componentWillMount(){
    this.setState({
      data: this.props.user,
      pass: {
        old_pass: '',
        new_pass: '',
        conf_pass: ''
      }
    });
  }

  componentWillReceiveProps(nextProps){
    if(this.props !== nextProps){
      if(nextProps.user.hasOwnProperty('user_lname')){
        this.setState({data: nextProps.user});
      }
    }
  }

  becomeBetter = e => {
    e.preventDefault();
    this.props.becomeBetter();
  }

  userChanged = () => {
    return !isEqual(this.props.user, this.state.data);
  }

  saveUser = e => {
    e.preventDefault();
    if(this.userChanged()){
      this.props.editUser(this.state.data);
    }
  }

  changePass = e => {
    e.preventDefault();
    this.props.changePass(this.state.pass, this.clearInput);
  }

  clearInput = () => {
    this.setState({
      pass:{
        old_pass: '',
        new_pass: '',
        conf_pass: ''
      }
    });
  }

  updateInput = e => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value
      }
    });
  }

  updatePassInput = e => {
    this.setState({
      pass: {
        ...this.state.pass,
        [e.target.name]: e.target.value
      }
    });
  }

  render() {
    if(!this.props.user.hasOwnProperty('user_lname')){
      return(<div>Не загружены данные</div>);
    }
    const { user } = this.props;
    const { data, pass } = this.state;

    const saveButton = this.userChanged() ? <button
        type="button"
        className="btn btn-warning"
        onClick={this.saveUser}>
        Сохранить
      </button> :
      '';

    const applyPass = (pass.old_pass.length>0 || pass.new_pass.length>0 || pass.conf_pass.length>0) ?
      ((pass.old_pass.length>7 && pass.new_pass.length>7 && pass.conf_pass.length>7) ?
        (pass.new_pass === pass.conf_pass ?
          <button
            type="button"
            className="btn btn-warning"
            onClick={this.changePass}>
            Применить
          </button>
          : 'Новый пароль не совпадает с подтверждением')
        : 'Пароль не может быть короче 8 символов')
      :'';

    return (
      <div>
        <h3 className="pull-right">Пользователь {user.user_login}</h3>
        <div className="form-group">
          <button type="button" className="btn btn-default"
            onClick={this.becomeBetter}>
            Стать лучше
          </button>{" "}
          {saveButton}
        </div>
        <div>
          <div className="form-horizontal">
            <div className="form-group">
              <div className="col-sm-offset-2 col-sm-4">
                <h4>Ваши данные:</h4>
              </div>
            </div>
            <div className="form-group">
              <label className="control-label col-md-2">Имя</label>
              <div className="col-md-4">
                <input
                  className="form-control"
                  value={data.user_fname}
                  name="user_fname"
                  onChange={this.updateInput}
                />
              </div>
              {data.user_fname.length>0?'':<span style={{color:'orange'}} className="glyphicon glyphicon-exclamation-sign"></span>}
            </div>
            <div className="form-group">
              <label className="control-label col-md-2">Фамилия</label>
              <div className="col-md-4">
                <input
                  className="form-control"
                  value={data.user_lname}
                  name="user_lname"
                  onChange={this.updateInput}
                />
              </div>
              {data.user_lname.length>0?'':<span style={{color:'orange'}} className="glyphicon glyphicon-exclamation-sign"></span>}
            </div>
            <div className="form-group">
              <label className="control-label col-md-2">Телефон</label>
              <div className="col-md-4">
                <MaskedInput
                  mask="+7 (111) 111-1111"
                  className="form-control"
                  value={data.user_tel}
                  name="user_tel"
                  onChange={this.updateInput}
                />
              </div>
              {data.user_tel.length>0?'':<span style={{color:'orange'}} className="glyphicon glyphicon-exclamation-sign"></span>}
            </div>
            <div className="form-group">
              <label className="control-label col-md-2">Должность</label>
              <div className="col-md-4">
                <input
                  className="form-control"
                  value={data.user_text}
                  name="user_text"
                  onChange={this.updateInput}
                />
              </div>
              {data.user_text.length>0?'':<span style={{color:'orange'}} className="glyphicon glyphicon-exclamation-sign"></span>}
            </div>
          </div>
        </div>
        <div>
          <form className="form-horizontal">
            <div className="form-group">
              <div className="col-sm-offset-2 col-sm-4">
                <h4>Здесь можно сменить пароль:</h4>
              </div>
            </div>
            <div className="form-group">
              <label className="col-sm-2 control-label">Старый пароль</label>
              <div className="col-sm-4">
                <input type="password" className="form-control"
                  placeholder="Старый пароль" name="old_pass" value={pass.old_pass}
                  onChange={this.updatePassInput}
                />
              </div>
            </div>
            <div className="form-group">
              <label className="col-sm-2 control-label">Новый пароль</label>
              <div className="col-sm-4">
                <input type="password" className="form-control"
                  placeholder="Новый пароль" name="new_pass" value={pass.new_pass}
                  onChange={this.updatePassInput}
                />
              </div>
            </div>
            <div className="form-group">
              <label className="col-sm-2 control-label">Подтверждение</label>
              <div className="col-sm-4">
                <input type="password" className="form-control"
                  placeholder="Подтверждение" name="conf_pass" value={pass.conf_pass}
                  onChange={this.updatePassInput}
                />
              </div>
            </div>
            <div className="col-sm-offset-2">
              {applyPass}
            </div>
          </form>
        </div>
      </div>
    );
  }
}

function mapOrdersToProps(store) {
  return {
    user: store.auth.user
  }
}

export default connect(mapOrdersToProps, { editUser, becomeBetter, changePass })(UserdataPage);



// WEBPACK FOOTER //
// ./src/components/userdata/UserdataPage.js